'use strict';

var toPull = require('stream-to-pull-stream');

var pull = require('pull-stream');

var transformChunk = require('./bw-util');

var deferred = require('pull-defer');

module.exports = function (send) {
  return function (opts) {
    opts = opts || {};
    var p = deferred.source();
    send({
      path: 'stats/bw',
      qs: opts
    }, function (err, stream) {
      if (err) {
        return p.end(err);
      }

      p.resolve(pull(toPull.source(stream), pull.map(transformChunk)));
    });
    return p;
  };
};